import defaultLogo from '@/assets/logotype.svg'

export const defaultWhiteLabel = {
  logoUrl: defaultLogo,
  darkHeader: false,
  color: '#D2A565',
  secondaryColor: '#D2A565'
}

export const skylineConfig = {
  color: '#0f3e87',
  secondaryColor: '#808f5a'
}

export const defaultAccountChartColors = [['#D2A563', '#D2A563'], ['#423817', '#423817'], ['#707070', '#707070'], ['#4A4A4A', '#4A4A4A'], ['#A37F4B', '#A37F4B']]

export const skylineAccountChartColors = [['bg-blue-darkest', 'bg-blue-darker'], ['bg-blue-dark', 'bg-blue'], ['bg-blue-light', 'bg-blue-lighter'], ['bg-grey-darkest', 'bg-grey-chart'], ['bg-black', 'bg-gold-darker'], ['bg-gold-dark', 'bg-gold']]

export const defaultSelectChartColors = ['#D2A563', '#423817', '#707070', '#4A4A4A', '#A37F4B', '#242424']

export const skylineSelectChartColors = ['#6c7f42', '#525645', '#cfddac', '#b3d667', '#919191', '#4A4A4A', '#A37F4B', '#242424']

export const basicPages = ['login', 'register', 'reset-password']

export const faviconDimensions = {
  'apple-touch-icon': [57, 60, 72, 76, 114, 120, 144, 152, 180],
  icon: [192, 32, 96, 16]
}
